import { STABLE_BOT_CATALOG } from '@warcarp/api-types'

/** Legacy/null or unknown identities must not open a human or broken profile. */
export function botProfilePath(profile?: string | null): `/(app)/bots/${string}` | null {
  return STABLE_BOT_CATALOG.some((bot) => bot.key === profile)
    ? `/(app)/bots/${profile}`
    : null
}

/** Resolve a game participant to the public profile surface they actually own. */
export function playerProfilePath(player: {
  isBot: boolean
  botProfile?: string | null
  username?: string | null
}): `/(app)/bots/${string}` | `/(app)/u/${string}` | null {
  if (player.isBot) return botProfilePath(player.botProfile)
  const username = player.username?.trim()
  return username ? `/(app)/u/${encodeURIComponent(username)}` : null
}
